import axios from "axios";

const generarFilesOpenData = async (idOpenData) => {
  try {
    const params = {
      id_opendata: idOpenData,
      "env:outSR": "",
      "env:processSR": "",
      returnZ: false,
      returnM: false,
      returnTrueCurves: false,
      context: "",
      f: "pjson",
    };

    const { data: responseAxios } = await axios.get(
      "https://www.medellin.gov.co/servidormapas/rest/services/ServiciosPlaneacion/getopendata/GPServer/getopendata/submitJob",
      {
        params,
      }
    );

    return responseAxios;
  } catch (err) {
    throw err;
  }
};

export default generarFilesOpenData;
